<ng-template #popContent>
  <div>
    <span style="display:inline;">
      <!-- <button style="float: right; top: -40px; position: relative" (click)="p.close()"><i class="fa fa-close text-danger"></i></button> -->
      @for (action of actionTable; track action) {
        @if (action.isRowVisible(params.data)) {
          <button [ngClass]="action.actionClass" class="ps-table-action-link" [disabled]="action.disabled(params.data)"
            (click)="action.action(params.data); p.close()">
            @if (action.iconClass) {
              <i [ngClass]="action.iconClass"></i>
            }
            {{action.name}}
          </button>
        }
      }
    </span>
  </div>
</ng-template>
<div style="width: 0px" container="body" [ngbPopover]="popContent" #p="ngbPopover" popoverTitle="Actions" triggers="manual" placement="bottom top"></div>
<span>
  <!-- <i style="font-size:14pt; color:#9aa184; padding-right:10px; padding-left:0px;" class="fa fa-bars" container="body" [ngbPopover]="popContent" #p="ngbPopover" popoverTitle="Actions - {{candidateName}}" triggers="manual" (click)="p.open()"></i> -->
  <!-- <a [routerLink]="['view', params?.data?.assessmentRequestId]" >-->
  <strong class="aniborder">
    @if (showConfidentialLock) {
      <i class="fa fa-lock" ngbTooltip="Confidential Request" container="body"></i>
    }
    {{candidateName}}
    @if (showAdditionalServiceIcon) {
      <i class="fa fa-plus-square-o" ngbTooltip="Additional request for development feedback" container="body"></i>
    }
    @if (showUpgradeServiceIcon) {
      <i class="fa fa-arrow-circle-o-up" ngbTooltip="Additional request for an upgraded assessment" container="body"></i>
    }
    @if (showAdditionalServiceParentIcon) {
      <i class="fa fa-square-o" ngbTooltip="This request has additional service(s)" container="body"></i>
    }
    @if (showAdditionalServicesCompleteParentIcon) {
      <i class="fa fa-check-square-o" ngbTooltip="Additional service(s) complete" container="body"></i>
    }
  </strong>
<!-- </a> -->
</span>
